import { TeamMemberRole } from '@api'
import { useUnit } from 'effector-react'

import { Page } from '@/components/layout/page/page'
import { $account } from '@/models/account.ts'
import { $creators, loadCreatorsFx } from '@/models/creators.ts'
import { useGetFilteredShiftsEntities } from '@/modules/shifts/hooks/use-get-filtered-shifts-entities'
import { ShiftsFilters } from '@/modules/shifts/ui/filters'
import { ShiftHistoryTable } from '@/modules/shifts/views/history-table'
import { useFetchTeamTable } from '@/modules/team/hooks/use-fetch-team-table'
import { AppRoutes } from '@/utils/constants'

export const ShiftsHistoryView = () => {
  const account = useUnit($account)
  const creators = useUnit($creators)
  const isFetchingCreators = useUnit(loadCreatorsFx.pending)
  const isAdminOrLeader = [TeamMemberRole.ADMIN, TeamMemberRole.LEADER].some(
    (role) => role === account?.memberRole,
  )
  const { data: employees, isFetching: isFetchingEmployees } =
    useFetchTeamTable({ enabled: isAdminOrLeader })

  const isFiltersDataLoading = isFetchingCreators || isFetchingEmployees

  const { data, isLoading, filters, setFilters, filterShiftByPeople } =
    useGetFilteredShiftsEntities(
      'shiftsHistory',
      { to: new Date() },
      creators,
      employees,
      isFiltersDataLoading,
    )

  return (
    <Page
      title="Shift History"
      className="[&_.back-to-page]:mb-6 [&_.page-header]:flex-1"
      titleClassName="leading-10 mr-6"
      backToPage={{
        name: 'Shifts',
        url: AppRoutes.Shifts.List.asUrl(),
      }}
      headerOptions={
        <ShiftsFilters
          includeTeamMembers={isAdminOrLeader}
          teamMembers={employees}
          includeDateRange
          values={filters}
          onChange={setFilters}
          className="lg:justify-end"
          creators={creators}
        />
      }
    >
      <ShiftHistoryTable
        isLoading={isLoading}
        data={data ?? []}
        filterShiftByPeople={filterShiftByPeople}
        creators={creators}
      />
    </Page>
  )
}
